import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

const DATADOG_RUM_APPLICATION_ID = '271a9d25-bbf8-46e7-aa91-9677af26dd55';
const DATADOG_RUM_CLIENT_TOKEN = 'pubf11481ffca92f4e9cc9cd3e44f64870f';
const DATADOG_RUM_YP_TEAM_ID = '6745f2777f0ef48eee781a86';
const DATADOG_RUM_YP_SERVICE_ID = '67461c1168694e9da68f896a';

if (environment.production) {
  enableProdMode();
}

if (environment.datadogRumEnv && (window as any).DD_RUM) {
  (window as any).DD_RUM.onReady(() => {
    (window as any).DD_RUM.init({
      applicationId: DATADOG_RUM_APPLICATION_ID,
      clientToken: DATADOG_RUM_CLIENT_TOKEN,
      site: 'datadoghq.com',
      service: 'monorail_js',
      env: environment.datadogRumEnv,
      version: environment.version,
      trackUserInteractions: true,
      trackResources: true,
    });
    (window as any).DD_RUM.setGlobalContextProperty('twdcgrid.yp_team_id', DATADOG_RUM_YP_TEAM_ID);
    (window as any).DD_RUM.setGlobalContextProperty('twdcgrid.yp_service_id', DATADOG_RUM_YP_SERVICE_ID);
  });
}

platformBrowserDynamic().bootstrapModule(AppModule);



// WEBPACK FOOTER //
// ./src/main.ts